export default {
    getPickupCode: '/api/web/v3/pickup/getpickupcode',//生成取餐码
    complete: '/api/web/v3/pickup/complete',//取餐完成
    getPickupList: '/api/web/v3/pickup/getpickuplist',//查询有效期内的咖啡领取列表
    info: '/api/web/v3/pickup/info',//查询配置信息查询配置信息

}